import { RFXTypes } from 'data/BusinessConstants';
import { RFIRequestForm, RFIType } from 'interfaces/RFIRequestForm';
import { RFXRequestState } from 'interfaces/RFXRequestForm';
import { timestampToDateString } from 'util/DatetimeUtils';

export const RFIWizardStep = {
  GeneralInformation: 0,
  InviteSuppliers: 1,
  Documents: 2,
  Correspondence: 3,
  CoManagers: 4,
  Review: 5
};

export const NEW_RFI_REQUEST_FORM: RFIRequestForm = {
  state: RFXRequestState.DRAFT,
  rfxRequestVersion: 1,
  generalInformation: {
    fullRfxId: '',
    rfxName: '',
    rfxType: RFXTypes.RFI,
    rfiType: RFIType.RFI,
    buyer: '',
    regions: [],
    sites: [],
    businessId: '',
    beginDate: timestampToDateString({ timestamp: Date.now() }),
    beginTime: '00:00',
    dueDate: '',
    dueTime: '23:59',
    categories: [],
    subCategories: [],
    project: '',
    overview: '',
    processDetails: '',
    workflow: ''
  },
  correspondence: {
    subject: '',
    body: '',
    bodyText: ''
  },
  suppliers: {
    supplierEntries: [],
    existingSupplierContactsMap: {}
  },
  'co-managers': { coManagerEntries: [] },
  documents: {
    documentEntries: [],
    supportDocuments: []
  },
  review: {},
  trackingInformation: {}
};
